import { GATEWAY_URL } from 'constants/index';
import { getCountry, getFieldValue, getRecipientSubdomain } from 'selectors';

export const getGatewayUrl = state => `${GATEWAY_URL}?${getQueryParams(state)}`;

const getQueryParams = state => {
  return [
    ...getCountryName(state),
    ...getSubdomain(state),
    ...getProvider(),
    ...getAmount(state),
  ].join('&');
};

const getCountryName = state => {
  const id = getFieldValue(state, 'sender_country');
  const { name } = getCountry(state, id);
  return name ? [`country=${name}`] : [];
};

const getSubdomain = state => {
  const subdomain = getRecipientSubdomain(state);
  return [`payment_destination=${subdomain}`];
};

const getProvider = () => ['provider=widget'];

const getAmount = state => {
  const amount = getFieldValue(state, 'amount');
  if (!amount) {
    return [];
  }
  return [`amount=${amount}`];
};
